import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";
import Common               from "Utils/Common";

// Types
import {
    MATERIAL_LOADING, MATERIAL_CHARGING,
    MATERIAL_LIST, MATERIAL_ELEM, MATERIAL_CREATE,
} from "Utils/Types";



// The initial State
const initialState = {
    loading    : false,
    charging   : false,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    position   : 0,
    courses    : [],
    categories : [],
    sort       : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate     = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.typeName        = Common.getMaterialType(elem.type);
    elem.statusName      = Status.getFemName(elem.status);
    elem.statusColor     = Status.getColor(elem.status);
    elem.statusClass     = Status.getTextClass(elem.status);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, MATERIAL_LIST, MATERIAL_ELEM, MATERIAL_CREATE)) {
        return { ...state, loading : false, charging : false, error : true };
    }

    switch (action.type) {
    case MATERIAL_LOADING:
        return {
            ...state,
            loading    : true,
        };
    case MATERIAL_CHARGING:
        return {
            ...state,
            charging   : true,
        };

    case MATERIAL_LIST:
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : parseList(action.data.list),
            total      : action.data.total,
            sort       : action.data.sort,
        };

    case MATERIAL_ELEM:
        return {
            ...state,
            charging   : false,
            error      : false,
            edition    : state.edition + 1,
            canEdit    : action.data.canEdit,
            position   : action.data.position,
            courses    : action.data.courses,
            categories : action.data.categories,
            elem       : parseElem(action.data.elem),
        };

    case MATERIAL_CREATE:
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            position   : action.data.position,
            courses    : action.data.courses,
            categories : action.data.categories,
        };

    default:
        return state;
    }
};

export default reducer;
